import React from "react";
const Impressum = () => {
  return (
    <React.Fragment>
      <div className="impressum container">
        <div className="impressum__inside container__inside">
          <h3>Angaben gemäß § 5 TMG:</h3>
          <ul>
            <li>Timo Grützediek</li>
            <li>von-Bodelschwinghstraße 17</li>
            <li>40667 Meerbusch</li>
            <li>015123074484</li>
            <li>timo@timogede.com</li>
          </ul>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Impressum;
